











































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseInputColor from "@/app/shared/components/base/BaseInputColor.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseInputStepping from "@/app/shared/components/base/BaseInputStepping.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BasePositionCheckbox from "@/app/shared/components/base/BasePositionCheckbox.vue";
import draggable from "vuedraggable";
import BaseSelect from "@/app/shared/components/base/BaseSelect.vue";
import BaseSelectFooter from "@/app/shared/components/base/BaseSelectFooter.vue";
import { VPopover, VClosePopover } from "v-tooltip";
import OverlayCard from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/OverlaysControllerOverlayCard.vue";
import { NamingTemplates } from "../../../models/classes/NamingTemplates";

export default Vue.extend({
  name: "OverlaysController",
  components: {
    BaseSimpleSlider,
    BaseButton,
    BaseInputColor,
    BaseInput,
    BaseInputStepping,
    BaseSearchInput,
    BaseCheckbox,
    BasePositionCheckbox,
    draggable,
    BaseSelect,
    BaseSelectFooter,
    VPopover,
    OverlayCard,
  },
  directives: {
    "close-popover": VClosePopover,
  },
  data: function () {
    return {
      drag: false,
      fonts: [
        /* { id: "default-0", name: "'Arial'", title: "Arial" }, */
        { id: "default-1", name: "'Roboto'", title: "Roboto" },
        { id: "default-2", name: "'Open Sans'", title: "Open Sans" },
        { id: "default-3", name: "'Montserrat'", title: "Montserrat" },
        { id: "default-4", name: "'Impact'", title: "Impact" },
      ],
    };
  },
  props: {
    isMultiSelectMode: {
      type: Boolean,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        //TODO need refactor
        filter: [
          ".overlay-card__top-block__options",
          ".overlay-card__main-block__preview",
          ".overlay-card__main-block__parameters",
          ".overlay-card__animation-block",
          ".base-position-checkbox",
          ".font-options",
          ".base-input",
          ".base-select",
          ".base-select-footer",
          ".base-input-color",
          ".base-input-easy",
          ".base-input-circle-color",
          ".overlay-card__main-block__layer__settings__eye",
          ".overlay-card__main-block__layer__settings__additional",
          ".colorpicker-button",
        ].join(","),
        preventOnFilter: false,
      };
    },
    currentVariationName: function () {
      let variationName = NamingTemplates.getVariationOutputFileName(
        this.previewItem.currentVariation,
        this.$store.state.items.indexOf(this.$store.state.selectedItem) + 1,
        this.$store.state.items
          .reduce((acc, val) => acc.concat(val.variations), [])
          .indexOf(this.previewItem.currentVariation) + 1,
        this.$store.state.userInfo.isInHouse
      );
      return variationName;
    },
  },
  created() {
    $eventsBus.$on(
      "updateOverlayPosition",
      (overlay, updateSame, clearTransforms) => {
        this.changeOverlayPosition(
          overlay,
          overlay.position,
          updateSame,
          clearTransforms
        );
        this.updateMoveables();
      }
    );

    $eventsBus.$on("updateAllDurationForAnimation", (overlay, speed, val) => {
      this.updateAllDurationForAnimation(overlay, speed, val);
    });
  },
  mounted() {
    this.loadAndSortDefaultGoogleFonts();
    this.loadAllUserFonts();
  },
  methods: {
    updateAllDurationForAnimation(overlay, speed, val) {
      if (overlay?.file?.duration && overlay?.file?.duration?.isControlled) {
        const mainDuration = overlay.file.duration.main;

        const startTimeVideo = !val ? overlay.startTime : val[0];
        const finishTimeVideo = !val ? overlay.finishTime : val[1];

        const oldValueMainDuration = overlay.getAnimationPropAtPath(
          overlay.file.json,
          mainDuration.op.path
        );

        overlay.updatePropInAnimationPath(
          (overlay.getAnimationPropAtPath(
            overlay.file.json,
            overlay.file.fps.path
          ) *
            (finishTimeVideo - startTimeVideo)) /
            speed,
          overlay,
          overlay.file.json,
          mainDuration.op.path
        );

        if (overlay?.file?.duration?.layers) {
          overlay.file.duration.layers.forEach((layer) => {
            overlay.updatePropInAnimationPath(
              (overlay.getAnimationPropAtPath(
                overlay.file.json,
                layer.ip.path
              ) *
                overlay.getAnimationPropAtPath(
                  overlay.file.json,
                  mainDuration.op.path
                )) /
                oldValueMainDuration,
              overlay,
              overlay.file.json,
              layer.ip.path
            );

            overlay.updatePropInAnimationPath(
              (overlay.getAnimationPropAtPath(
                overlay.file.json,
                layer.op.path
              ) *
                overlay.getAnimationPropAtPath(
                  overlay.file.json,
                  mainDuration.op.path
                )) /
                oldValueMainDuration,
              overlay,
              overlay.file.json,
              layer.op.path
            );
          });
        }
        if (overlay?.file?.timers) {
          if (overlay?.file?.timers?.layers) {
            overlay.file.timers.layers.forEach((layer) => {
              overlay.updatePropInAnimationPath(
                (overlay.getAnimationPropAtPath(
                  overlay.file.json,
                  layer.ip.path
                ) *
                  overlay.getAnimationPropAtPath(
                    overlay.file.json,
                    mainDuration.op.path
                  )) /
                  oldValueMainDuration,
                overlay,
                overlay.file.json,
                layer.ip.path
              );

              overlay.updatePropInAnimationPath(
                (overlay.getAnimationPropAtPath(
                  overlay.file.json,
                  layer.op.path
                ) *
                  overlay.getAnimationPropAtPath(
                    overlay.file.json,
                    mainDuration.op.path
                  )) /
                  oldValueMainDuration,
                overlay,
                overlay.file.json,
                layer.op.path
              );
            });
          }
        }
      }
    },
    loadAndSortDefaultGoogleFonts() {
      let cyrillicFontsArray = [
        "Alegreya",
        "Alegreya SC",
        "Alegreya Sans",
        "Alegreya Sans SC",
        "Alice",
        "Amatic SC",
        "Andika",
        "Anonymous Pro",
        "Arimo",
        "Arsenal",
        "Bad Script",
        "Balsamiq Sans",
        "Bellota",
        "Bellota Text",
        "Bitter",
        "Caveat",
        "Comfortaa",
        "Commissioner",
        "Cormorant",
        "Cormorant Garamond",
        "Cormorant Infant",
        "Cormorant SC",
        "Cormorant Unicase",
        "Cousine",
        "Cuprum",
        "Didact Gothic",
        "EB Garamond",
        "El Messiri",
        "Exo 2",
        "Fira Code",
        "Fira Mono",
        "Fira Sans",
        "Fira Sans Condensed",
        "Fira Sans Extra Condensed",
        "Forum",
        "Gabriela",
        "Hachi Maru Pop",
        "IBM Plex Mono",
        "IBM Plex Sans",
        "IBM Plex Serif",
        "Inter",
        "Istok Web",
        "JetBrains Mono",
        "Jost",
        "Jura",
        "Kelly Slab",
        "Kosugi",
        "Kosugi Maru",
        "Kurale",
        "Ledger",
        "Literata",
        "Lobster",
        "Lora",
        "M PLUS 1p",
        "M PLUS Rounded 1c",
        "Manrope",
        "Marck Script",
        "Marmelad",
        "Merriweather",
        "Montserrat Alternates",
        "Neucha",
        "Noto Sans",
        "Noto Serif",
        "Nunito",
        "Old Standard TT",
        "Open Sans Condensed",
        "Oranienbaum",
        "Oswald",
        "PT Mono",
        "PT Sans",
        "PT Sans Caption",
        "PT Sans Narrow",
        "PT Serif",
        "PT Serif Caption",
        "Pacifico",
        "Pangolin",
        "Pattaya",
        "Philosopher",
        "Piazzolla",
        "Play",
        "Playfair Display",
        "Playfair Display SC",
        "Podkova",
        "Poiret One",
        "Prata",
        "Press Start 2P",
        "Prosto One",
        "Raleway",
        "Roboto Condensed",
        "Roboto Mono",
        "Roboto Slab",
        "Rubik",
        "Rubik Mono One",
        "Ruda",
        "Ruslan Display",
        "Russo One",
        "Sawarabi Gothic",
        "Scada",
        "Seymour One",
        "Source Code Pro",
        "Source Sans Pro",
        "Source Serif Pro",
        "Spectral",
        "Spectral SC",
        "Stalinist One",
        "Tenor Sans",
        "Tinos",
        "Ubuntu",
        "Ubuntu Condensed",
        "Ubuntu Mono",
        "Underdog",
        "Viaoda Libre",
        "Vollkorn",
        "Vollkorn SC",
        "Yanone Kaffeesatz",
        "Yeseva One",
      ];

      cyrillicFontsArray.forEach((f, i) => {
        const link = document.createElement("link");
        link.href =
          `https://fonts.googleapis.com/css?family=` +
          f.replace(/ /g, "+") +
          `:300,400,500,700&amp;subset=cyrillic`;
        link.rel = "stylesheet";
        document.head.appendChild(link);
        this.fonts.push({
          id: "default-google-" + i,
          name: "'" + f + "'",
          title: f,
        });
      });

      this.fonts.sort((a, b) => (a.title > b.title ? 1 : -1));
    },

    updateMoveables() {
      $eventsBus.$emit("updateAllMoveables");
    },

    openOverlaysLibraryWindow(overlay?) {
      this.$store.commit("showOverlaysLibraryWindow", true);
      if (overlay) {
        setTimeout(() => {
          $eventsBus.$emit("editOverlay", overlay);
        }, 100);
      }
    },
    changeOverlayPosition(
      overlay,
      positionName,
      updateSame = true,
      clearTransforms = true
    ) {
      const oldPosition = overlay.position;
      overlay.position = positionName;

      let left, top, right, bottom;

      const zeroPaddingNumber = 0;

      const initialPaddingNumber = 5;

      const convertToPercent = (padding) => `${padding}%`;

      switch (positionName) {
        case "left-top":
          left = convertToPercent(initialPaddingNumber);
          top = convertToPercent(initialPaddingNumber);
          right = "unset";
          bottom = "unset";
          break;
        case "center-top":
          left = "unset";
          top = convertToPercent(initialPaddingNumber);
          right = "unset";
          bottom = "unset";
          break;
        case "right-top":
          left = "unset";
          top = convertToPercent(initialPaddingNumber);
          right = convertToPercent(initialPaddingNumber);
          bottom = "unset";
          break;
        case "left-center":
          left = convertToPercent(initialPaddingNumber);
          top = "unset";
          right = "unset";
          bottom = "unset";
          break;
        case "center":
          left = "unset";
          top = "unset";
          right = "unset";
          bottom = "unset";
          break;
        case "right-center":
          left = "unset";
          top = "unset";
          right = convertToPercent(initialPaddingNumber);
          bottom = "unset";
          break;
        case "left-bottom":
          left = convertToPercent(initialPaddingNumber);
          top = "unset";
          right = "unset";
          bottom = convertToPercent(initialPaddingNumber);
          break;
        case "center-bottom":
          left = "unset";
          top = "unset";
          right = "unset";
          bottom = convertToPercent(initialPaddingNumber);
          break;
        case "right-bottom":
          left = "unset";
          top = "unset";
          right = convertToPercent(initialPaddingNumber);
          bottom = convertToPercent(initialPaddingNumber);
          break;

        case "left-top-border":
          left = convertToPercent(zeroPaddingNumber);
          top = convertToPercent(zeroPaddingNumber);
          right = "unset";
          bottom = "unset";
          break;
        case "center-top-border":
          left = "unset";
          top = convertToPercent(zeroPaddingNumber);
          right = "unset";
          bottom = "unset";
          break;
        case "right-top-border":
          left = "unset";
          top = convertToPercent(zeroPaddingNumber);
          right = convertToPercent(zeroPaddingNumber);
          bottom = "unset";
          break;
        case "left-center-border":
          left = convertToPercent(zeroPaddingNumber);
          top = "unset";
          right = "unset";
          bottom = "unset";
          break;
        case "right-center-border":
          left = "unset";
          top = "unset";
          right = convertToPercent(zeroPaddingNumber);
          bottom = "unset";
          break;
        case "left-bottom-border":
          left = convertToPercent(zeroPaddingNumber);
          top = "unset";
          right = "unset";
          bottom = convertToPercent(zeroPaddingNumber);
          break;
        case "center-bottom-border":
          left = "unset";
          top = "unset";
          right = "unset";
          bottom = convertToPercent(zeroPaddingNumber);
          break;
        case "right-bottom-border":
          left = "unset";
          top = "unset";
          right = convertToPercent(zeroPaddingNumber);
          bottom = convertToPercent(zeroPaddingNumber);
          break;

        default:
          left = "unset";
          top = "unset";
          right = "unset";
          bottom = "unset";
          break;
      }

      overlay.moveabaleStyle.left = left;
      overlay.moveabaleStyle.top = top;
      overlay.moveabaleStyle.right = right;
      overlay.moveabaleStyle.bottom = bottom;

      if (updateSame) {
        this.changeCheckedItems(
          overlay,
          false,
          false,
          false,
          false,
          false,
          false,
          oldPosition
        );
      }
      //Important to do it at last
      if (clearTransforms) {
        overlay.transforms = {
          scaleX: 1,
          scaleY: 1,
          translateX: 0,
          translateY: 0,
          rotate: 0,
        };
      }
    },
    moveArrayItemToNewIndex(array, object, toIndex) {
      array.splice(toIndex, 0, array.splice(array.indexOf(object), 1)[0]);
    },
    shiftOverlayUp(variation, overlay, isChangeChecked = true) {
      let overlaysToCheck =
        variation.overlays.indexOf(overlay) !== -1
          ? variation.overlays
          : variation.overlaysOfBackside;

      if (
        overlaysToCheck.indexOf(overlay) === 0 &&
        overlaysToCheck === variation.overlaysOfBackside
      ) {
        this.sendOverlayToFront(variation, overlay, false);
      } else {
        let newIndex =
          overlaysToCheck.indexOf(overlay) !== 0
            ? overlaysToCheck.indexOf(overlay) - 1
            : 0;
        this.moveArrayItemToNewIndex(overlaysToCheck, overlay, newIndex);
      }

      if (isChangeChecked) {
        this.changeCheckedItems(overlay, false, false, true, false);
      }
    },
    shiftOverlayDown(variation, overlay, isChangeChecked = true) {
      let overlaysToCheck =
        variation.overlays.indexOf(overlay) !== -1
          ? variation.overlays
          : variation.overlaysOfBackside;

      if (
        overlaysToCheck.indexOf(overlay) === overlaysToCheck.length - 1 &&
        overlaysToCheck === variation.overlays
      ) {
        this.sendOverlayToBack(variation, overlay, false);
      } else {
        let newIndex =
          overlaysToCheck.indexOf(overlay) !== overlaysToCheck.length - 1
            ? overlaysToCheck.indexOf(overlay) + 1
            : overlaysToCheck.length - 1;
        this.moveArrayItemToNewIndex(overlaysToCheck, overlay, newIndex);
      }
      if (isChangeChecked) {
        this.changeCheckedItems(overlay, false, false, false, true);
      }
    },
    sendOverlayToBack(variation, overlay, isChangeChecked = true) {
      let indexInOverlays = variation.overlays.indexOf(overlay);
      if (indexInOverlays !== -1) {
        variation.overlaysOfBackside.push(
          variation.overlays.splice(indexInOverlays, 1)[0]
        );
      } else {
        this.moveArrayItemToNewIndex(
          variation.overlaysOfBackside,
          overlay,
          variation.overlaysOfBackside.length - 1
        );
      }
      if (isChangeChecked) {
        this.changeCheckedItems(
          overlay,
          false,
          false,
          false,
          false,
          true,
          false
        );
      }
    },
    sendOverlayToFront(variation, overlay, isChangeChecked = true) {
      let indexInOverlaysOfBackside = variation.overlaysOfBackside.indexOf(
        overlay
      );
      if (indexInOverlaysOfBackside !== -1) {
        variation.overlays.unshift(
          variation.overlaysOfBackside.splice(indexInOverlaysOfBackside, 1)[0]
        );
      } else {
        this.moveArrayItemToNewIndex(variation.overlays, overlay, 0);
      }
      if (isChangeChecked) {
        this.changeCheckedItems(
          overlay,
          false,
          false,
          false,
          false,
          false,
          true
        );
      }
    },
    duplicateOverlay(overlay) {
      let overlaysToUpdate =
        this.previewItem.currentVariation.overlays.indexOf(overlay) !== -1
          ? this.previewItem.currentVariation.overlays
          : this.previewItem.currentVariation.overlaysOfBackside;
      let newTwinnedId = `t${(~~(Math.random() * 1e8)).toString(16)}`;
      this.changeCheckedItems(
        overlay,
        false,
        true,
        false,
        false,
        false,
        false,
        null,
        newTwinnedId
      );
      let overlayCopy = overlay.copy();
      overlayCopy.twinnedId = newTwinnedId;
      overlaysToUpdate.push(overlayCopy);
      this.updateMoveables();
      this.$store.commit("addNewStateToHistory");
    },
    deleteOverlay(overlay) {
      let overlaysToUpdate =
        this.previewItem.currentVariation.overlays.indexOf(overlay) !== -1
          ? this.previewItem.currentVariation.overlays
          : this.previewItem.currentVariation.overlaysOfBackside;
      overlaysToUpdate.splice(overlaysToUpdate.indexOf(overlay), 1);
      this.changeCheckedItems(overlay, true);
      this.$store.commit("addNewStateToHistory");
    },
    isItTextObject(overlayObject) {
      return overlayObject.type === "text";
    },
    isItShapeObject(overlayObject) {
      return overlayObject.type === "shape";
    },
    isItAnimationObject(overlayObject) {
      return overlayObject.type === "animation";
    },
    //deprecated
    getOverlayTransform(overlay) {
      let transforms = overlay.transforms;
      return (
        "translate(" +
        (transforms.translateX ? transforms.translateX : 0) +
        "px, " +
        (transforms.translateY ? transforms.translateY : 0) +
        "px) " +
        "rotate(" +
        (transforms.rotate ? transforms.rotate : 0) +
        "deg) scale3d(" +
        (transforms.scaleX ? transforms.scaleX : 1) +
        ", " +
        (transforms.scaleY ? transforms.scaleY : 1) +
        ", 1)"
      );
    },
    changeCheckedItems(
      overlay,
      isDelete,
      isDuplicate,
      isShiftUp,
      isShiftDown,
      isSendOverlayToBack,
      isSendOverlayToFront,
      oldPosition,
      newTwinnedId
    ) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      return this.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked)
        .forEach((v) => {
          let sameOverlays = [];
          v.getAllOverlays()
            .filter((o) => {
              return (
                (this.isItTextObject(overlay)
                  ? o.value === overlay.value
                  : this.isItAnimationObject(overlay)
                  ? o?.file?.id && o.file.id === overlay.file.id
                  : JSON.stringify(o.file) ===
                    JSON.stringify(overlay.file)) /*TODO need check it */ &&
                o.id !== overlay.id &&
                o.twinnedId ===
                  overlay.twinnedId /* 
                this.getOverlayTransform(o) ===
                  this.getOverlayTransform(overlay) &&
                (oldPosition
                  ? o.position === oldPosition
                  : o.position === overlay.position) */
              );
            })
            .forEach((o) => {
              if (oldPosition) {
                //Be careful. Recursion is possible
                this.changeOverlayPosition(o, overlay.position, false);
              }
              if (isDelete || isDuplicate) {
                sameOverlays.push(o);
              }
              if (isShiftUp) {
                this.shiftOverlayUp(v, o, false);
              }
              if (isShiftDown) {
                this.shiftOverlayDown(v, o, false);
              }
              if (isSendOverlayToBack) {
                this.sendOverlayToBack(v, o, false);
              }
              if (isSendOverlayToFront) {
                this.sendOverlayToFront(v, o, false);
              }
            });
          sameOverlays.forEach((o) => {
            let overlaysToUpdate =
              v.overlays.indexOf(o) !== -1 ? v.overlays : v.overlaysOfBackside;
            if (isDelete) {
              overlaysToUpdate.splice(overlaysToUpdate.indexOf(o), 1);
            }
            if (isDuplicate) {
              let oCopy = o.copy();
              oCopy.twinnedId = newTwinnedId;
              overlaysToUpdate.push(oCopy);
            }
          });
        });
    },
    loadNewFont(): void {
      (<HTMLElement>this.$refs.fileInput).click();
    },
    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(files);
      event.target.value = "";
    },
    validateAndUploadFiles(files) {
      let result: File[] = [];
      const maxCount = 10;
      let maxIndex = files.length > maxCount ? maxCount : files.length;
      for (var i = 0; i < maxIndex; i++) {
        result.push(<File>files.item(i));
      }
      this.uploadFiles(result);
    },
    uploadFiles(files: File[]) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let data = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        data.append("files[" + i + "]", file);
      }
      data.append("sessionId", this.$store.state.userInfo.sessionId);

      let route = "/fonts/filesUploadMulti";

      this.axios
        .post(route, data, config)
        .then((res) => {
          res.data.forEach((font) => {
            this.importUserFont(font);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadAllUserFonts() {
      this.axios
        .post(
          "/fonts/getFonts",
          {
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          response.data.forEach((font) => {
            this.importUserFont(font);
          });
        });
    },
    deleteFont(font) {
      let isDelete = this.checkAllItemsVariationsOverlayWithFont(font);
      if (isDelete) {
        this.fonts.splice(
          this.fonts.indexOf(this.fonts.find((f) => f.id === font.id)),
          1
        );
        const config = {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        };
        let route = "/fonts/remFonts";
        this.axios
          .post(
            route,
            {
              id: font.id,
              sessionId: this.$store.state.userInfo.sessionId,
            },
            config
          )
          .then((res) => {
            this.$forceUpdate();
            this.updateMoveables();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    checkAllItemsVariationsOverlayWithFont(fontToDelete) {
      let overlaysWithFontToDelete = [];
      let message = "";
      this.items.forEach((item) => {
        item.variations.forEach((variation) => {
          variation.getAllOverlays().forEach((o) => {
            if (this.isItTextObject(o) && o.style.font.id === fontToDelete.id) {
              overlaysWithFontToDelete.push(o);
            }
          });
        });
      });
      message =
        "This font is using in " +
        overlaysWithFontToDelete.length +
        " overlays. It's will be changed to 'Roboto'. Continue?";
      if (overlaysWithFontToDelete.length > 0) {
        let isDelete = confirm(message);
        if (isDelete) {
          overlaysWithFontToDelete.forEach((o) => {
            o.style.font = this.fonts[0];
          });
        }
        return isDelete;
      } else {
        return true;
      }
    },
    importUserFont(font) {
      const style = document.createElement("style");
      let fontSrc = "";
      font.path.forEach((path, i) => {
        if (path.src !== "") {
          fontSrc += i === 0 ? "" : ",";
          if (path.type === "woff") {
            fontSrc += ` url(${this.$baseURL + path.src}) format('woff')`;
          } else if (path.type === "ttf") {
            fontSrc += ` url(${this.$baseURL + path.src}) format('truetype')`;
          } else if (path.type === "oet") {
            fontSrc += ` url(${this.$baseURL + path.src})`;
          }
        }
      });
      let normal =
        `
      @font-face {
        font-family: '${font.name}';
        src:` +
        fontSrc +
        `;
		font-weight: normal;
		font-style: normal;
		}`;
      let italic =
        `
      @font-face {
        font-family: '${font.name}';
        src:` +
        fontSrc +
        `;
		font-weight: normal;
		font-style: italic;
		}`;
      let bold =
        `
      @font-face {
        font-family: '${font.name}';
        src:` +
        fontSrc +
        `;
		font-weight: bold;
		font-style: normal;
		}`;
      let boldItalic =
        `
      @font-face {
        font-family: '${font.name}';
        src:` +
        fontSrc +
        `;
		font-weight: bold;
		font-style: italic;
		}`;
      style.innerHTML = normal + italic + bold + boldItalic;

      document.head.appendChild(style);
      this.fonts.push({
        id: font.id,
        name: "'" + font.name + "'",
        title: font.name,
      });
    },
  },
});
